module.exports = __webpack_public_path__ + "static/img/public.9145747.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/public.png
// module id = CJoD
// module chunks = 1